// extracted by mini-css-extract-plugin
module.exports = {"overlay":"OverlayLoader_overlay__2PeoK","top":"OverlayLoader_top__3SlBG","overlayTop":"OverlayLoader_overlayTop__JdNwE"};